import { deckSectionComponents } from './deck-section.js'
import { deckComponents } from './deck.js'
import { finalizeActionComponents } from './finalize-actions.js'
import { handrailEndComponents } from './handrail-end.js'
import { projectedEntityComponents } from './projected-entity.js'
import { stairsComponents } from './stairs.js'

export const customComponents = [
  ...deckComponents,
  ...finalizeActionComponents,
  ...deckSectionComponents,
  ...stairsComponents,
  ...projectedEntityComponents,
  ...handrailEndComponents,
]
